/**
 * collabPeers — the count of connected free-mode room peers, surfaced reactively
 * to widgets. Fed by Libp2pYjsProvider's `onPeersChanged` (wired in
 * useEditorDoc); read by ImageWidget to tell "backing up" (a peer is online to
 * replicate to) from "no one else here yet" (nothing can back up).
 *
 * Module-level singleton — one collab session per tab, like the other collab
 * stores; reset to 0 on teardown.
 */
import { useSyncExternalStore } from "react";

let count = 0;
const listeners = new Set<() => void>();

/** Set the live room-peer count (0 when solo / collab off). */
export function setRoomPeerCount(n: number): void {
  if (n === count) return;
  count = n;
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

/** Reactive count of connected room peers (0 in solo mode). */
export function useRoomPeerCount(): number {
  return useSyncExternalStore(
    subscribe,
    () => count,
    () => 0,
  );
}
